export default __webpack_public_path__ + "static/media/anay_bhat.25ee802d.jpg";